import Routes from './routes';
import axios from '../../../../plugin/axios';

export const getNotifications = (recipient) =>
  axios.get(Routes.notifications, {
    params: recipient ? { recipient } : {},
  });

export const markNotificationAsRead = (id) =>
  axios.patch(`${Routes.notifications}${id}/`, {
    is_read: true,
  });

export const createNotification = (payload) => axios.post(Routes.notifications, payload);

export const getOrganizationEmails = () => axios.get(`${Routes.notifications}organization-emails/`);
